import React from 'react';
import { ClickupConnectionPanel } from '../components/ClickupConnectionPanel';
import { PlaneConnectionPanel } from '../components/PlaneConnectionPanel';
import { RepoMappingsCard } from './RepoMappingsCard';

function ConnectionsPage() {
  return (
    <div className="workspaceConnectionsPage">
      <section className="taskProviderConnections">
        <header>
          <div>
            <h2>Task trackers</h2>
            <p>
              Choose where Cindro reads work items from. Each task keeps its
              provider and status.
            </p>
          </div>
        </header>
        <ClickupConnectionPanel />
        <PlaneConnectionPanel />
      </section>
      <section className="repositoryConnections">
        <header>
          <div>
            <h2>Code repositories</h2>
            <p>
              Link GitHub repositories to the projects and delivery tracks they
              belong to.
            </p>
          </div>
        </header>
        <RepoMappingsCard />
      </section>
    </div>
  );
}

export { ConnectionsPage };
